import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from "./logo.svg";
import "./App.css";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";

import Index from "./pages/index";
import Page from "./pages/arretrati";
import ProductPage from "./pages/product";
import AboutUs from "./pages/chi_siamo";
import ContactUs from "./pages/contact";
import ContactUsTest from "./pages/contact_test";
import NotFound from "./pages/notFound";
import Abbonamenti from "./pages/abbonamenti";
import LoginPage from "./pages/login_page";
import Profile from "./pages/profile";
import ScrollToTop from "./Components/ScrollToTop";
import CheckoutForm, {
  Return,
  SubscribeCheckoutForm,
  RinnovoCheckoutForm,
} from "./pages/checkout2";
import Cart from "./pages/cart";
import OrderDetails from "./Components/order_details";
import AbbCartaceo from "./pages/abbonamento_page";
import ResetPassword from "./pages/ResetPassword";
import Subscribe from "./pages/subscribe";
import AdminDashboard from "./pages/admin_dashboard";
import UserManagement from "./pages/admin_user_management";
import GestioneRiviste, { NuovaRivista } from "./pages/gestioneRivista";
import AdminRiviste from "./pages/adminRiviste";
import ManageSubscription from "./pages/admin_subscription_management";
import ProtectedRoute from "./pages/AdminRoute";
import Unauthorized from "./pages/unauthorized";
import Video from "./pages/video";
import GestioneOrdini from "./pages/gestione_ordini";
import GestioneFAQs from "./pages/gestioneFaqs";
import NotificationPage from "./pages/admin_notification";
import TermsAndConditions, { PoliticheDiReso } from "./pages/policy";
import Indici from "./pages/indici";

function App() {
  const [key, setKey] = useState(0);

  const forceHeaderReload = () => {
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <div className="App">
      <BrowserRouter key={key}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/home" element={<Index />} />
          <Route path="/chi-siamo" element={<AboutUs />} />
          <Route path="/supporto" element={<ContactUsTest />} />
          <Route path="/video" element={<Video />} />
          <Route path="/checkout-regalo" element={<CheckoutForm />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/passwordReset" element={<ResetPassword />} />
          <Route path="/abbonamenti" element={<Abbonamenti />} />
          <Route path="/abbonamenti/:slug" element={<AbbCartaceo />} />
          <Route
            path="/subscribe-checkout"
            element={<SubscribeCheckoutForm />}
          />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/rinnovo" element={<RinnovoCheckoutForm />} />
          <Route path="/arretrati" element={<Page />} />
          <Route path="/arretrati/:slug" element={<ProductPage />} />
          <Route path="/profilo" element={<Profile />} />
          <Route path="/indici" element={<Indici />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/carrello" element={<Cart />} />
          <Route path="/checkout" element={<CheckoutForm />} />
          <Route path="/return" element={<Return />} />
          <Route
            path="/profilo/ordini/:orderId/dettagli"
            element={<OrderDetails />}
          />
          <Route
            path="/termini-e-condizioni"
            element={<TermsAndConditions />}
          />
          <Route path="/politiche-di-reso" element={<PoliticheDiReso />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/riviste"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminRiviste />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/riviste/:slug"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <GestioneRiviste />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/riviste/nuova-rivista"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <NuovaRivista />
              </ProtectedRoute>
            }
          />
          ;
          <Route
            path="/admin/gestione-abbonamenti"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ManageSubscription />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/gestione-ordini"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <GestioneOrdini />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/gestione-faqs"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <GestioneFAQs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/notifiche"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <NotificationPage />
              </ProtectedRoute>
            }
          />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
